import {eventBus, EVENTS} from './commons/EventBus.js';
const refresh=180*1000;
let inter;

eventBus.on(EVENTS.PAGE_AFTER_RENDERING, function (data) {
  const template = data.template;
  if(inter){
    clearInterval(inter);
    inter=null;
  }
  if (template != "rds_social_tv") {
    return;
  }
  if(!inter){
    inter=setInterval(function(){
      $("#player-social-tv-full-image").attr("src",`https://media.rds.it/smarttv/cameras/socialtv?t=${new Date().getTime()}`);
    },refresh);
  }

})





